import { GraphQlClient } from '@intelipost-js/secure-providers';

export default {
  getCtesList({ commit }, param) {
    commit('recon/preInvoiceDetail/toggleLoading', true, { root: true });
    return GraphQlClient.query(`
      query ($id: String!, $action: String!) {
        preInvoiceDetail(id: $id, action: $action) {
          cte {
            order_number
            tracking_code
            products_value
            total_value
            invoice {
              number
              serie
              key
            }
            cte_list {
              cte_type
              infos_cte {
                number
                serie
                key
                validation_date
                issue_date
                protocol_number
                sefaz_validation_date
                status_sefaz_code
                status_sefaz
                status_cte
                file_origin
                file_name
              }
            }
          }
        }
      }`, param)
    .then(({ data }) => {
      const { preInvoiceDetail = {} } = data || {};
      const { cte = {} } = preInvoiceDetail || {};

      commit('setCtes', cte);
      commit('recon/preInvoiceDetail/toggleLoading', false, { root: true });
      return cte;
    })
    .catch(() => {
      commit('recon/preInvoiceDetail/toggleLoading', false, { root: true });
    });
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-recon/features/pre-invoice-detail/components/sc-pre-invoice-detail-ctes/store/actions.js